import React, { useState, useEffect,useContext } from "react";
import quizThumb from '../assets/images/quiz-default.jpg';
import Footer from "../components/footer/Footer";
import Header from "../components/header/Header";
import tmdbApi from "../api/tmdbApi";
import { useHistory, useLocation } from "react-router-dom";
import { contentContext } from "../context/contentContext";
import SweetAlert from 'react-bootstrap-sweetalert';
import moment from "moment";

const LogIn = () => {
    const history = useHistory();
    const { state } = useLocation();
    const { flag } = state || {};
    const { clientInfo,setClientInfo } = useContext(contentContext)
    const [quizData, setQuizData] = useState(null);
    const [formData, setFormData] = useState({
        name: "",
        emailid: "",
    });
    const [pwd, setPwd] = useState("");
    const [showPwd, setShowPwd] = useState(false);
    const [username, setUsername] = useState("");
    const [confirmPwd, setConfirmPwd] = useState("");
    const [errorData, setError] = useState("");
    const [errorDisplay, setErrorDisplay] = useState(false);
    const [imageCloudfront, setImg] = useState("");
    const [showForgotPwd,setShowForgotPwd]=useState(false);
    const [  showCnfPwd, setShowCnfPwd]=useState(false);
  const [success,setSuccess]=useState(false)
    useEffect(()=>{
        if (!localStorage.getItem("token1")) {
            history.push("/login");
        }else{
            history.push("/");
        }
    },[])
  
    useEffect(() => {
        const updateImageCloudfront = () => {
            if (window.site?.common?.imageCloudfront) {
                setImg(window.site.common.imageCloudfront);
            }
        };

        updateImageCloudfront();
        const timeout = setTimeout(updateImageCloudfront, 1000);
        return () => clearTimeout(timeout);
    }, []);

    useEffect(() => {
        if (flag) {
            const handlePopState = (event) => {
                event.preventDefault();
                history.push('/');
            };

            window.history.pushState({}, document.title, window.location.href);
            window.addEventListener("popstate", handlePopState);

            return () => {
                window.removeEventListener("popstate", handlePopState);
            };
        }
    }, [flag, history]);

    useEffect(() => {
        window.scrollTo(0, 0);
        const quizinfo = JSON.parse(localStorage.getItem('q'));
        if (quizinfo) setQuizData(quizinfo);

        const userinfo = JSON.parse(localStorage.getItem('u'));
        if (userinfo) setFormData(userinfo);
    }, []);

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };
console.log("username",username)

const loginPwd = async () => {
    try {
        
        const response = await tmdbApi.Login({
            "username": username,
            "password": pwd,
          
        });
        console.log(response);
        if (response?.statusCode == 200 && response?.result === "Invalid username or password") {
            setError(response?.result);
            setTimeout(function () { setError("") }, 3000);
            // setBtnLoader("")
        } else if (response?.result === "Session Already Exists") {
            // signoutsession()
            // setShowSessionPopup(true)
            // setBtnLoader("")
        } else {
            localStorage.setItem("token1", response?.result.token);
            localStorage.setItem("clientid", response?.result.clientid);
         
            GetUserDataSignIn()
            // localStorage.setItem("userId", response?.result.userid);
            // // GetUserDataSignIn();
            // localStorage.setItem("loginTime",moment().format('DD-MMM-YYYY HH:mm:ss'))
            // // history.push("/usermanagement");
            history.push("/")
        }
       

    } catch {
        console.log("error");
        // setBtnLoader("")
        setError("Invalid username or password");
        setTimeout(function () { setError("") }, 3000);
    }
};

    const handleSignIn = (e) => {
        e.preventDefault();
      
        if (!username && !pwd) {
            setError("Please enter Username and Password");
        } else if (!username) {
            setError("Please enter Username");
        } else if (!pwd) {
            setError("Please enter Password");
        } else {
            console.log("Sign In Successful");
            // Call login API or handle sign-in logic
            loginPwd()
        }

        setErrorDisplay(true);
        // setTimeout(() => setErrorDisplay(false), 3000);
    };

    const handleBack = () => {
        history.push("/");
    };
    
     
    
    const handleCreate = async () => {
        const uppercaseRegex = /[A-Z]/;
        const lowercaseRegex = /[a-z]/;
        const numberRegex = /\d/;
        if(!pwd){
            setErrorDisplay(true);
            setError("Please Enter New password");
         }else if(!uppercaseRegex.test(pwd)){
            setErrorDisplay(true);
              setError("Password must contain at least one uppercase letter");
         }else if(!lowercaseRegex.test(pwd)){
            setErrorDisplay(true);
           setError("Password must contain at least one lowercase letter");
      }else if(!numberRegex.test(pwd)){
        setErrorDisplay(true);
       setError("Password must contain at least one  number ");
  }else
         if(!confirmPwd){
             setErrorDisplay(true);
             setError("Please Enter Confirm password");
          } else
        if (pwd !== confirmPwd) {
            setErrorDisplay(true);
          setError("Confirm Password does not match New Password");
          return; // Exit early if passwords don't match
        }else{
            try {
                const response = await tmdbApi.clientForgotPwdGenerate({
                  username: username,
                  password: pwd,
                });
            
                console.log(response);
            
                if (response?.statusCode === 200) {
                  if (response?.result === "User not found") {
                   setError("User not found")
                   setErrorDisplay(true)
                    // console.error("Invalid token or expired");
                  } else {
                setSuccess(true)
                  setConfirmPwd(false)
                  setShowPwd(false);
                  setPwd("")
                  setUsername("")
                  setConfirmPwd("")
                  setShowCnfPwd(false)
                  }
                } else {
                  // Handle other status codes
                  console.error("Unexpected response status:", response?.statusCode);
                }
              } catch (error) {
                console.error("An error occurred while processing the request:", error);
              }
        }
      
       
      };
      const onConfirm=()=>{
        setShowForgotPwd(false);
setSuccess(false)
      }
    const handleCancel=()=>{
        setShowForgotPwd(false);
        setUsername("");
        setPwd("");
        setShowCnfPwd("")
        setShowPwd("")
        setConfirmPwd("")
        setErrorDisplay(false);
    }
    const handleForgotPwd=()=>{
        if(!username){
            setErrorDisplay(true)
            setError("Please enter username")
        }else{
            setShowForgotPwd(true);
            setPwd("");
        }
      
    }
    const GetUserDataSignIn = async () => {
        try {

            const response = await tmdbApi.getClientData({});

            if (response?.statusCode === 200) {

                setClientInfo(response?.result?.[0]);

                // localStorage.setItem("ClientName", response?.result?.[0]?.name)
                // localStorage.setItem("ClientType", response?.result?.[0]?.type)
                // let userArr = response?.result?.[0]?.permissions
                // const EMAILID = response?.result?.[0]?.emailid
                // console.log('user email',EMAILID)
                // window.clarity("set", "orasi_user_email", EMAILID)
                // // Clarity.addTag('Orasi User Email', EMAILID);
                // const obj = userArr.reduce((acc, item) => {
                //     if (item.submenus) acc[item.menu] = false;
                //     return acc;
                // }, {});
                // // console.log('objjjjjjjj--->',obj)

                // if(!(localStorage.getItem("check"))){
                // let k = response?.result?.[0]

                // let permissionList = response && response?.result && response?.result?.[0] && response?.result?.[0]?.permissions
                // let filterdList = permissionList.filter((item) => item.display == true)
                // const data= filterdList?.filter((value)=>value?.menu==="Dashboard")
                // let id = data && data[0] && data[0].menu.split(" ").join("").toLowerCase()

                // history.push("/" + id);
                

                // setActiveMenuId(data && data[0] && data[0].menuid)
                // console.log("activeMenuid------->",data)
                // }

                // setActiveMenuObj(obj)
                // setBtnLoader("")
                // console.log('response?.result?.[0] kkkkkkkkkk', response?.result?.[0])
            }
        } catch {
            // setBtnLoader("")
            console.log("error");
        }
    };

    return (
        <main>
            <Header />
            <div className="form_block login_block">
                <div className="wrp">
                    <div className="form">
                        <div className="sign_in">
                            <h3 className="sub_title">{showForgotPwd?"Create Password":"Sign in"}</h3>
                            <div className="form-group">
                                <label>User Name <span>*</span></label>
                                <input
                                disabled={showForgotPwd}
                                    type="text"
                                    name="username"
                                    onChange={(e) => {
                                        setUsername(e.target.value);
                                        setErrorDisplay(false);
                                      }}
                                    value={username}
                                    className="form-control"
                                    placeholder="User Name"
                                />
                            </div>
                            <div className="form-group">
                                <label>{showForgotPwd?"New Password":"Password"}<span>*</span></label>
                                <div className="position-relative" >
                                <input
                                     type={showPwd ? "text" : "password"}
                                    name="pwd"
                                    
                                    onChange={(e) => {
                                        setPwd(e.target.value)
                                        setErrorDisplay(false);
                                      }}
                                    value={pwd}
                                    className="form-control"
                                    placeholder="Password"
                                />
                                 <span
        onClick={() => setShowPwd(!showPwd)}
        className="material-icons icon" >
        {showPwd ? "visibility_off" : "visibility"} {/* Use emojis or Unicode characters */}
      </span>
      </div>
                             
                            </div>
                            {showForgotPwd&& <div className="form-group">
                                <label>Confirm Password <span>*</span></label>
                                <div className="position-relative">
                                <input
        type={showCnfPwd ? "text" : "password"}
        name="confirmpwd" 
      
        onChange={(e) => {
            setConfirmPwd(e.target.value);
            setErrorDisplay(false);
          }}
        value={confirmPwd}
        className="form-control"
        placeholder="Password"
      />
      <span
        onClick={() => setShowCnfPwd(!showCnfPwd)}
          className="material-icons icon icon"
      >
        {showCnfPwd ? "visibility_off" : "visibility"} {/* Use emojis or Unicode characters */}
      </span>
      </div>
                              
                            </div>}
                            {errorDisplay && (
                                    <span className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>
                                        {errorData}
                                    </span>
                                )}
                            <div className="d_flex">
                            {showForgotPwd ? (
  <div className="btns">
    <button className="vs_btn mr-10"onClick={handleCreate}>Create Password</button>
    <button onClick={handleCancel} className="border_btn">Cancel</button>
  </div>
) : (
  <>
    <div className="btns">
      <button onClick={handleSignIn} className="vs_btn mr-10">Sign in</button>
      <button onClick={handleBack} className="border_btn">Cancel</button>
    </div>
    <p className="forgot">
      <a onClick={handleForgotPwd} className="link">Forgot password?</a>
    </p>
  </>
)}

                               
                               
                              
                            </div>
                            <p className="text">
    Don't have an account? <a href="/signup" className="link">Sign up</a>
</p>

                        </div>
                    </div>
                    <SweetAlert show={success}
                        custom
                        confirmBtnText="ok"
                        confirmBtnBsStyle="primary"
                        title={"Password created successfully"}
                        onConfirm={e => onConfirm()}
                    >
                    </SweetAlert>
                </div>
            </div>
            <Footer />
        </main>
    );
};

export default LogIn;
